import {
  MyModal,
  ModalContainer,
  Heading,
  Subtitle,
  Iconend,
  ModalIcon,
} from "./GradingModal.styles";
import CrossIcon from "../../assets/icons/cross.svg";
import One from "../../assets/images/A.png";
import Two from "../../assets/images/B.png";

interface GradingModalprops {
  heading?: string;
  subtitle?: string;
  imageOne?: any;
  open?: boolean;
  handleClose?(): void;
}

function GradingModal(props: GradingModalprops) {
  if (!props.open) return null;
  return (
    <ModalContainer>
      <MyModal>
        <Iconend>
          <ModalIcon onClick={props.handleClose} src={CrossIcon} alt="cross" />
        </Iconend>
        <div>
          <Heading>{props.heading}</Heading>
          <Subtitle>{props.subtitle}</Subtitle>
        </div>
        <div>
          <img
            src={props.imageOne}
            alt="example-image"
            style={{ width: "100%", maxWidth: "454px" }}
          />
        </div>
      </MyModal>
    </ModalContainer>
  );
}

export default GradingModal;
